<template>
  <el-dialog :visible.sync="innerVisible" :title="$t('CargoMsg.Cargo_Audit')+'/'+$t('CargoMsg.Cargo_Refuse')" width="400px" custom-class="cargo-form-dialog" :close-on-click-modal="false" @close="handleClose">
    <div style="width: 390px;padding: 10px;">
      {{ $t('CargoMsg.Cargo_DenialReasonP') }}
      <el-input v-model="remark" no="DenialReason" type="textarea" :rows="10" />
    </div>
    <span slot="footer" style="padding:10px;">
      <el-button no="Confirm" type="primary" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button no="Cancel" @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>

export default {
  name: 'RejectDialog',
  components: { },
  props: {
    visible: { type: Boolean, default: () => false },
    rejectCallBack: { type: Function, default: null }
  },
  data() {
    return {
      innerVisible: false,
      remark: ''
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
  },
  methods: {
    async handleSubmit() {
      if (this.rejectCallBack && await this.rejectCallBack(this.remark)) {
        this.handleClose()
      }
    },
    handleClose() {
      this.remark = ''
      this.innerVisible = false
    }
  }
}
</script>
<style lang="scss">
  .cargo-form-dialog{
    .el-dialog{
      &__header,&__body,&__footer{
        padding:10px 15px!important;
      }
      &__title{
        vertical-align: middle;
      }
      &__headerbtn{
        top:15px;
        right:15px;
      }
    }
  }
  .cargo-form{
    .el-form-item {
      &.label-none {
        .el-form-item__content{
          margin-left: 0;
        }
      }
    }
  }
</style>
